import React from "react";
import { toPersianNumber } from "../utils/numberConversion";

function Pagination({ currentPage, lastPage, onChange }) {
    if (!lastPage || lastPage <= 1) return null;
    return (
        <div className="pagination-bar d-flex align-items-center justify-content-center flex-wrap">
            <button
                type="button"
                className="btn btn-outline-orange pagination-btn"
                disabled={currentPage === 1}
                title="صفحه اول"
                onClick={() => onChange(1)}
            >
                <i className="bi bi-chevron-bar-right"></i>
            </button>
            <button
                type="button"
                className="btn btn-outline-blue pagination-btn"
                disabled={currentPage === 1}
                title="صفحه قبل"
                onClick={() => onChange(currentPage - 1)}
            >
                <i className="bi bi-chevron-right"></i>
            </button>
            <span className="pagination-info">
                صفحه {toPersianNumber(currentPage)} از {toPersianNumber(lastPage)}
            </span>
            <button
                type="button"
                className="btn btn-outline-blue pagination-btn"
                disabled={currentPage === lastPage}
                title="صفحه بعد"
                onClick={() => onChange(currentPage + 1)}
            >
                <i className="bi bi-chevron-left"></i>
            </button>
            <button
                type="button"
                className="btn btn-outline-orange pagination-btn"
                disabled={currentPage === lastPage}
                title="صفحه آخر"
                onClick={() => onChange(lastPage)}
            >
                <i className="bi bi-chevron-bar-left"></i>
            </button>
        </div>
    );
}

export default Pagination;
